import React, { useState, useEffect, useContext } from 'react'
import { Table, Container, ProgressBar } from 'react-bootstrap'
import { Helmet } from 'react-helmet'
// import latestNewsData from '../data/latestNews.json'
import Pagination from 'rc-pagination'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import { AuthContext } from './AuthContext'

const LatestNews = ({ currentUser, setLoginShow, setRedirectTo }) => {
  const { baseUrl, sendDiscordNotification } = useContext(AuthContext)
  const getListUrl = '/api/crm/news/getList'
  const [isLoading, setIsLoading] = useState(false)
  const [latestNewsData, setLatestNewsData] = useState([
    {
      clinic_news_id: 0,
      clinic_id: 0,
      title: '',
      type: 0,
      register_only: 0,
      is_top: 0,
      created_time: '',
    },
  ])

  // TODO: loading狀態 置頂

  useEffect(() => {
    setIsLoading(true)
    axios
      .get(baseUrl + getListUrl, {
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
          Accept: '*/*',
        },
      })
      .then((res) => {
        // console.log('getList', res)
        const sortedLatestNewsData = res.data.data.sort((a, b) =>
          b.created_time.localeCompare(a.created_time)
        )
        setLatestNewsData(sortedLatestNewsData)
      })
      .catch((e) => {
        console.log('getList error', e)
        sendDiscordNotification(`LatestNews Error \n Error: ${e} `)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [])

  // 一頁有幾項
  const [size, setSize] = useState(10)
  const [current, setCurrent] = useState(1)
  // console.log('LatestNews currentUser', currentUser)
  const PerPageChange = (value, size) => {
    setSize(value)
    const newPerPage = Math.ceil(latestNewsData.length / size)
    if (current > newPerPage) {
      setCurrent(newPerPage)
    }
  }

  const getData = (current, pageSize) => {
    // Normally you should get the data from the server
    return latestNewsData.slice((current - 1) * pageSize, current * pageSize)
  }

  const PaginationChange = (page, pageSize) => {
    setCurrent(page)
    setSize(pageSize)
  }

  // TODO:頁碼有問題
  // TODO:頁碼query
  const PrevNextArrow = (current, type, originalElement) => {
    if (current !== 0 && type === 'prev') {
      return (
        <button>
          <i className="fa fa-angle-left"></i>
        </button>
      )
    }
    if (type === 'next') {
      // console.log(current)
      return (
        <button>
          <i className="fa fa-angle-right"></i>
        </button>
      )
    }
    return originalElement
  }
  const navigate = useNavigate()
  // const handleShow = () => setModalShow(true)

  const isLogin = (v) => {
    // console.log('currentUser', setLoginShow)
    if (currentUser) {
      navigate(`/currentNews/${v.clinic_news_id}`)
    } else {
      if (v.register_only === 0) {
        navigate(`/currentNews/${v.clinic_news_id}`)
      } else {
        setLoginShow(true)
        setRedirectTo(`/currentNews/${v.clinic_news_id}`)
      }
    }
  }

  return (
    <>
      <Helmet>
        <title>最新消息 | HA! CRM</title>
      </Helmet>
      <Container className="latestNews text-center">
        <div className="title">
          <h1>HA! 健康數據管理平台</h1>
          <h2>最新消息</h2>
        </div>

        {isLoading ? (
          <div className="m-5">
            <ProgressBar className="m-4" animated now={100} />
            <h5 className="text-secondary">資料等待中...</h5>
          </div>
        ) : (
          <>
            <div className="newsTable">
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th style={{ width: '200px' }}>類別</th>
                    <th>標題</th>
                    <th style={{ width: '200px' }}>文章狀態</th>
                    <th style={{ width: '200px' }}>日期</th>
                  </tr>
                </thead>
                <tbody>
                  {/* 置頂訊息 */}
                  {getData(current, size)
                    .filter((v) => v.is_top === 1)
                    .map((v) => {
                      return (
                        <tr
                          onClick={() => {
                            isLogin(v)
                          }}
                          className="pinToTop"
                          key={v.clinic_news_id}
                          style={{ cursor: 'pointer' }}
                        >
                          <td>{v.type === 0 ? '系統訊息' : '徵詢訊息'}</td>
                          <td>{v.title}</td>
                          <td>
                            {v.register_only === 0 ? '公開訊息' : '僅限會員'}
                          </td>
                          <td>{v.created_time}</td>
                        </tr>
                      )
                    })}
                  {getData(current, size)
                    .filter((v) => v.is_top === 0)
                    .map((v) => {
                      return (
                        <tr
                          onClick={() => {
                            isLogin(v)
                          }}
                          key={v.clinic_news_id}
                          style={{ cursor: 'pointer' }}
                        >
                          <td>{v.type === 0 ? '系統訊息' : '徵詢訊息'}</td>
                          <td>{v.title}</td>
                          <td>
                            {v.register_only === 0 ? '公開訊息' : '僅限會員'}
                          </td>
                          <td>{v.created_time}</td>
                        </tr>
                      )
                    })}
                </tbody>
              </Table>
            </div>
            <Pagination
              className="pagination-data mt-5"
              // showTotal={(total, range) =>
              //   `Showing ${range[0]}-${range[1]} of ${total}`
              // }
              onChange={PaginationChange}
              total={latestNewsData.length}
              current={current}
              pageSize={size}
              showSizeChanger={false}
              itemRender={PrevNextArrow}
              onShowSizeChange={PerPageChange}
              locale={{
                prev_page: '上一頁',
                next_page: '下一頁',
              }}
            />
          </>
        )}
      </Container>
    </>
  )
}

export default LatestNews
